import { inject } from "@angular/core";
import { CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { GoogleTagManagerService } from "./shared/data/services/google-tag-manager.service";
import { CheckoutTrackingService } from "./shared/data/services/checkout-tracking.service";

/**
 * Trasa `/creator`: wczytuje GTM przed utworzeniem komponentów kreatora,
 * żeby zdarzenia e-commerce z ich `ngOnInit` trafiały do dataLayer
 * po `gtm.js`. Przy wejściu zapamiętuje też identyfikatory kliknięć z URL
 * (`gclid`, `gbraid`, `wbraid`, `fbclid`) – trafią do rezerwacji.
 */
export const loadGtmGuard: CanActivateFn = (route): boolean => {
  inject(GoogleTagManagerService).load();
  inject(CheckoutTrackingService).captureEntryAttribution(route?.queryParamMap);
  return true;
};

/**
 * Trasy bez GTM (`/panel`, `/login`, `/reset-password`). Jeśli GTM został
 * wczytany wcześniej w tej sesji SPA (np. kreator → „Zaloguj” → panel),
 * przerywa nawigację i przeładowuje stronę pod docelowym adresem – po pełnym
 * załadowaniu GTM nie jest już wstrzykiwany.
 *
 * Musi być PIERWSZY w tablicy `canActivate`: synchroniczne `false` kończy
 * sprawdzanie i anuluje pozostałe guardy (np. `authGuard` z przekierowaniem
 * na `/login`).
 */
export const gtmFreeGuard: CanActivateFn = (_route, state: RouterStateSnapshot): boolean => {
  const gtm = inject(GoogleTagManagerService);
  if (!gtm.isLoaded()) return true;
  gtm.reloadPageAt(state.url);
  return false;
};
